export type UserLevel = 'basic' | 'expert'
export const USER_LEVEL: Record<UserLevel, UserLevel> = {
  basic: 'basic',
  expert: 'expert',
}
